// Update contents object below

const contents = {
  header: 'Destination Canada',
  logoTooltip: {
    href: 'https://us-keepexploring.canada.travel/',
    copy: 'https://us-keepexploring.canada.travel/',
    logoPlacement: 'above'
  },
  video:
    'https://player.vimeo.com/video/880567093?badge=0&amp;autopause=0&amp;quality_selector=1&amp;player_id=0&amp;app_id=58479',
  videoTitle: 'Destination Canada - Ep. 5  Québec',
  videoAutoPlay: true,
  title: 'episode 5: Québec',
  copy: 'This baker, author, and podcaster explores human connection and history by baking breads from different cultures around the world. As Bryan journeys through Québec, literally breaking bread with its artisans, chefs, and knowledge-keepers, he discovers what truly nourishes them and brings meaning to the place they call home.',
  url: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/',
  button: 'return to hub',
  url2: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/alberta/'
};

export default contents;
